import React, { Component } from 'react'
import PropTypes from "prop-types"
import { connect } from "react-redux"

import GenericMap from "visualizations/components/GenericMap"

import { selectMapProps } from "search-new/selectors"
import { loadMapGeographyData } from "search-new/action-creators"
import { toggleValue } from 'shared/imports/sharedHelperFunctions'

export class MapWrapper extends Component {
    static propTypes = {
        // from ListViewDisplayWrapper
        uniqueFlvId: PropTypes.string.isRequired,
        uniqueVizSceneId: PropTypes.string.isRequired,
        // from containers/VisualizationDisplay/index
        data: PropTypes.object.isRequired,
        isVisualizationLoading: PropTypes.bool.isRequired,
        isVisualizationDataEmpty: PropTypes.bool.isRequired,
        storedGraphs: PropTypes.object.isRequired,
        configs: PropTypes.shape({
            geoDataUrl: PropTypes.string.isRequired,
            formatGeoData: PropTypes.func.isRequired,
            getLabelOffsets: PropTypes.func,
            outsideLabels: PropTypes.array,
            useResourceId: PropTypes.bool,
            getMapProjection: PropTypes.func.isRequired,
            hideLabels: PropTypes.bool,
        }),
        // from components/VisualizationDisplay/index (modified)
        updateFilter: PropTypes.func.isRequired,
        // from connect
        loadMapGeographyData: PropTypes.func.isRequired,
        selectedRegions: PropTypes.array.isRequired,
        formattedGeographyData: PropTypes.array.isRequired,
    }

    componentDidMount() {
        if (!this.props.formattedGeographyData.length) {
            this.props.loadMapGeographyData(
                this.props.configs.geoDataUrl,
                this.props.configs.formatGeoData,
            )
        }
    }

    updateGraph = (value) => {
        const currentlySelected = this.props.selectedRegions

        const newSelectedValues = toggleValue(this.props.selectedRegions, value)
        this.props.updateFilter(newSelectedValues)
    }

    render() {
        return (
            Boolean(this.props.formattedGeographyData.length) &&
            <GenericMap
                data={this.props.data.toJS()}
                updateGraph={this.updateGraph}
                selectedRegions={this.props.selectedRegions}
                isLoading={this.props.isVisualizationLoading}
                svgId={this.props.uniqueVizSceneId}
                useResourceId={this.props.configs.useResourceId}
                colorConfigs={this.props.colorConfigs}
                // geography data stuff
                geographyData={this.props.formattedGeographyData}
                configs={this.props.configs}
            />
        )
    }
}

export default connect(selectMapProps, { loadMapGeographyData })(MapWrapper)
